import Vue from 'vue'
Vue.config.devtools = true

import VueFuse from 'vue-fuse'
import './plugins/axios'
import App from '@/App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PortalVue from 'portal-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(PortalVue)
Vue.use(VueFuse)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
